import React from 'react';
import { motion } from 'framer-motion';
export function WhereToStart() {
  return <section className="py-32 bg-[#F5EBEB] relative overflow-hidden" data-id="element-359">
      {/* Decorative images */}
      <motion.img src="https://images.unsplash.com/photo-1544126592-807ade215a0b?auto=format&fit=crop&q=80" alt="Decorative" className="absolute -left-20 top-10 w-64 h-64 object-cover rounded-full opacity-40 mix-blend-multiply blur-[2px]" initial={{
      opacity: 0,
      x: -50
    }} whileInView={{
      opacity: 0.4,
      x: 0
    }} viewport={{
      once: true
    }} data-id="element-360" />
      <motion.img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&q=80" alt="Decorative" className="absolute -right-20 bottom-10 w-80 h-80 object-cover rounded-full opacity-30 mix-blend-multiply blur-[2px]" initial={{
      opacity: 0,
      x: 50
    }} whileInView={{
      opacity: 0.3,
      x: 0
    }} viewport={{
      once: true
    }} data-id="element-361" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-362">
        <motion.div className="bg-white/80 backdrop-blur-lg p-10 lg:p-16 rounded-3xl shadow-xl border border-white text-center" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-363">
          <h2 className="text-4xl lg:text-5xl font-serif text-charcoal mb-8" data-id="element-364">
            ¿Y si no sé por dónde empezar?
          </h2>
          <p className="text-lg lg:text-xl text-warmGray leading-relaxed mb-10" data-id="element-365">
            Si te sientes abrumado/a por tantas opiniones, métodos y miedos, no
            estás solo/a. Esta guía fue creada precisamente para ayudarte a
            ordenar la información, entender lo esencial y vivir esta etapa con
            más calma. No necesitas hacerlo perfecto; necesitas un punto de
            partida claro.
          </p>
          <button className="bg-mauve hover:bg-mauve/90 text-white px-10 py-4 rounded-lg font-medium transition-colors shadow-md text-lg" onClick={() => document.getElementById('cta-final')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-366">
            Quiero esta guía
          </button>
        </motion.div>
      </div>
    </section>;
}